import React from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import { Avatar } from "@material-ui/core";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import SlideGroup from "../../../common/components/slide/SlideGroup";
import "react-vertical-timeline-component/style.min.css";
import styles from "./TimelineItem.module.css";
import { makeStyles } from "@material-ui/core/styles";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import { Project } from "../../../models/project";
import PuiTypography from "../../../components/elements/PuiTypography";
import classNames from "classnames";

const useStyles = makeStyles(() => ({
    listIcon: {
        borderRadius: "0",
        boxShadow: "none",
    },
}));

interface ItemProps {
    // 年代ごとのプロジェクトリスト
    projectList?: Project[];
}

export default function TimelineItem({ ...props }: ItemProps) {
    const classes = useStyles();

    // スクロールコンテナの空白要素を追加
    // var addBlank = false
    // if ( !props.projectList ) {
    //     addBlank = true;
    // }

    return (
        <div>
            <VerticalTimeline layout="1-column" className={styles.littleTimeline} animate={false}>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    style={{ margin: "0", marginTop: "-10px", width: "1000px", height: "5px" }}
                    iconClassName={classes.listIcon}
                    contentStyle={{ boxShadow: "none", background: "none", height: "5px" }}
                ></VerticalTimelineElement>
                {props.projectList &&
                    props.projectList.map((project) => (
                        <VerticalTimelineElement
                            key={project.id}
                            className="vertical-timeline-element--work"
                            style={{ margin: "10px 0 0 0", width: "100%", top: "0%" }}
                            contentStyle={{
                                background: "var(--gray-85)",
                                borderRadius: "15px 15px 0 0",
                                height: "80px",
                                paddingRight: "0",
                                marginLeft: "70px",
                            }}
                            contentArrowStyle={{
                                height: "15px",
                                top: "35%",
                                border: "15px solid transparent",
                                borderRight: "15px solid var(--gray-85)",
                            }}
                            iconStyle={{
                                backgroundColor: "white",
                                border: "2px solid var(--main)",
                                width: "20px",
                                height: "20px",
                                marginLeft: "26px",
                                top: "35px",
                            }}
                        >
                            <div className={styles.balloon}>
                                <div
                                    className={classNames(
                                        "vertical-timeline-element-title",
                                        styles.itemTitle
                                    )}
                                    data-tip={project.title}
                                    data-for="project"
                                >
                                    <PuiTypography size={24} bold={true}>
                                        {project.title}
                                    </PuiTypography>
                                </div>
                                <div className={styles.avatarList}>
                                    <AvatarGroup max={3}>
                                        {project.professionals.map((professional) => (
                                            <Avatar
                                                key={professional.id}
                                                className={styles.avatar}
                                                style={{
                                                    float: "right",
                                                    width: "54px",
                                                    height: "54px",
                                                }}
                                                src={
                                                    process.env.REACT_APP_API_ENDPOINT +
                                                    professional.imageUrl
                                                }
                                            />
                                        ))}
                                    </AvatarGroup>
                                </div>
                                {/* Tooltip */}
                                <PuiTooltip id={"project"} />
                            </div>
                            <div className={styles.slideList}>
                                <SlideGroup
                                    title="a"
                                    id="a"
                                    videoListTransition={project.videos}
                                    displayNum={3}
                                    slideBetween={5}
                                    needLoop={false}
                                />
                            </div>
                        </VerticalTimelineElement>
                    ))}
            </VerticalTimeline>
        </div>
    );
}
